import React, { useState } from 'react';
import '../assets/css/common/index.module.scss';
import Styles from '../assets/css/layouts/layout.module.scss';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import Content from './Content';
import PopUpMessage from '../utils/errors/PopUpMessage';

const Layout = (props) => {

  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className={`${Styles.layout}`}>
      <Sidebar isOpen={sidebarOpen} sidebarData={props.sidebarUser}/>
      <Navbar onToggle={handleToggle}/>
      <Content />
      <PopUpMessage />
    </div>
  )
}

export default Layout
